import {mapStates, mapActions, mapMutations, mapGetters} from './../baseModule'
// import CouchdbClass from 'src/services/CouchdbClass'

const collection = 'roles'
const connection = 'config'

// const Couchdb = new CouchdbClass({connection: 'default', collection: collection})


const model = {
  name: '',
  label: '',
  permissions: []
}
const validations = {
  name: {
    required: true
  },
  permissions: {
    required: true,
    min: 5
  }
}
let getters = {...mapGetters()}
getters = Object.assign(getters, {
  role: state => state.one,
  roles: state => state.all,
  loading: state => state.loading,
  validations: state => state.validations,
  // O nome destas permissões não devem ser modificadas.
  // Se modificadas, há a necessidade de revalidar cada consulta no sistema
  permissions: state => {
    return {
      dashboard: {
        label: 'Dashboard',
        subModules: [
          {
            label: 'Dashboard',
            permissions: [
              {label: 'Visualizar', value: 'dashboard.overview'}
            ]
          }
        ],
        dashboard: [
          {label: 'Visualizar', value: 'dashboard.overview'}
        ]
      },
      manage: {
        label: 'Gerenciar',
        subModules: [
          {
            label: 'Eventos',
            permissions: [
              {label: 'Visualizar eventos', value: 'events.index'},
              {label: 'Criar eventos', value: 'events.create'},
              {label: 'Exibir detalhes dos eventos', value: 'events.details'},
              {label: 'Realizar sorteio', value: 'events.lottery'},
              {label: 'Visualizar apresentador', value: 'events.view.presenter'},
              {label: 'Download do apresentador', value: 'events.download.presenter'},
              {label: 'Associar estoque', value: 'events.link.stock'},
              {label: 'Imprimir todos os termos', value: 'events.print.terms'},
              {label: 'Editar eventos', value: 'events.edit'},
              {label: 'Remover eventos', value: 'events.remove'},
              {label: 'Baixar relatórios', value: 'events.reports.download'},
              {label: 'Download da documentação dos clientes', value: 'events.download.documents'},
              {label: 'Imprimir todos os tickets ganhadores', value: 'all.tickets.documents.print'},
              {label: 'Substituir ticket ganhador', value: 'events.tickets.replacements'},
              {label: 'Enviar fotos do evento', value: 'events.photos.upload'}
            ]
          },
          {
            label: 'Especificações',
            permissions: [
              {label: 'Auditoria do Ação/Evento', value: 'events.audit'},
              {label: 'Visualizar especificações', value: 'eventsSpecifications.index'},
              {label: 'Criar especificações', value: 'eventsSpecifications.create'},
              {label: 'Editar especificações', value: 'eventsSpecifications.edit'}
            ]
          },
          {
            label: 'Ranking',
            permissions: [
              {label: 'Visualizar/gerenciar ranking', value: 'ranking.index'},
              {label: 'Criar ranking', value: 'ranking.create'},
              {label: 'Marcar cliente como ausente no ranking', value: 'ranking.ticket.absent'},
              {label: 'Imprimir lista de vencedores', value: 'ranking.print.winners'}
            ]
          },
          {
            label: 'Pesquisas',
            permissions: [
              {label: 'Visualizar página de pesquisas', value: 'surveys.index'},
              {label: 'Associar pesquisas ao usuário', value: 'surveys.associate'},
              {label: 'Imprimir lista de associados', value: 'surveys.associated.tickets.print'},
              {label: 'Visualizar detalhes da pesquisas', value: 'surveys.view'},
              {label: 'Cancelar pesquisa realizada', value: 'surveys.cancel'}
            ]
          },
          {
            label: 'Clientes',
            permissions: [
              {label: 'Visualizar clientes', value: 'customers.index'},
              {label: 'Exibir detalhes do cliente', value: 'customer.detail'},
              {label: 'Cadastrar clientes', value: 'customers.create'},
              {label: 'Editar clientes', value: 'customers.edit'},
              {label: 'Remover clientes', value: 'customers.remove'},
              {label: 'Gerenciar tickets', value: 'customers.tickets'},
              {label: 'Trocar lâmpadas', value: 'customers.lamps'},
              {label: 'Imprimir ticket', value: 'tickets.print'},
              {label: 'Imprimir os termos de um cliente', value: 'documents.print'},
              {label: 'Imprimir o termo de troca lâmpada', value: 'lamps.print'}
            ]
          },
          {
            label: 'Estoques',
            permissions: [
              {label: 'Visualizar estoques', value: 'stock.index'},
              {label: 'Adicionar novo estoque', value: 'stock.create'},
              {label: 'Editar estoques', value: 'stock.edit'},
              {label: 'Remover estoques', value: 'stock.remove'}
            ]
          },
          {
            label: 'Tickets',
            permissions: [
              {label: 'Visualizar detalhes do ticket', value: 'tickets.details'},
              {label: 'Registrar presença', value: 'tickets.checkin'},
              {label: 'Enviar documentação', value: 'tickets.uploadDoc'},
              {label: 'Enviar imagem', value: 'tickets.uploadImg'},
              {label: 'Baixar documentação', value: 'tickets.downloadDoc'},
              {label: 'Marcar ticket para métrica', value: 'tickets.energyMetering'}
            ]
          },
          {
            label: 'Relatórios',
            permissions: [
              {label: 'Gerar relatórios', value: 'reports.index'}
            ]
          }
        ]
      },
      config: {
        label: 'Configurações',
        subModules: [
          {
            label: 'Usuários',
            permissions: [
              {label: 'Visualizar usuários', value: 'users.index'},
              {label: 'Adicionar usuários', value: 'users.create'},
              {label: 'Editar usuários', value: 'users.edit'},
              {label: 'Remover usuários', value: 'user.remove'},
              {label: 'Inativar usuário', value: 'user.inactivate'}
            ]
          },
          {
            label: 'Permissões do Sistema',
            permissions: [
              {label: 'Visualizar permissões', value: 'roles.index'},
              {label: 'Adicionar permissões', value: 'roles.create'},
              {label: 'Editar permissões', value: 'roles.edit'},
              {label: 'Remover permissões', value: 'roles.remove'}
            ]
          },
          {
            label: 'Projeto',
            permissions: [
              {label: 'Visualizar projeto', value: 'project.index'},
              {label: 'Editar projeto', value: 'project.edit'}
            ]
          },
          {
            label: 'Fabricantes',
            permissions: [
              {label: 'Visualizar fabricantes', value: 'manufacturers.index'},
              {label: 'Adicionar fabricantes', value: 'manufacturers.create'},
              {label: 'Editar fabricantes', value: 'manufacturers.edit'},
              {label: 'Remover fabricantes', value: 'manufacturers.remove'}
            ]
          },
          {
            label: 'Categorias',
            permissions: [
              {label: 'Visualizar categorias', value: 'categories.index'},
              {label: 'Adicionar categorias', value: 'categories.create'},
              {label: 'Editar categorias', value: 'categories.edit'},
              {label: 'Remover categorias', value: 'categories.remove'}
            ]
          },
          {
            label: 'Tags',
            permissions: [
              {label: 'Visualizar tags', value: 'tags.index'},
              {label: 'Adicionar tags', value: 'tags.create'},
              {label: 'Editar tags', value: 'tags.edit'},
              {label: 'Remover tags', value: 'tags.remove'}
            ]
          }
        ]
      },
      logs: {
        label: 'Logs',
        subModules: [
          {
            label: 'Logs',
            permissions: [
              {label: 'Visualizar logs do cliente', value: 'logs.custoemrs.show'},
              {label: 'Visualizar logs do ticket', value: 'logs.tickets.show'},
              {label: 'Visualizar logs do evento', value: 'logs.events.show'},
              {label: 'Visualizar logs do lâmpadas', value: 'logs.lamps.show'},
              {label: 'Visualizar logs do stocks', value: 'logs.stocks.show'}
            ]
          }
        ]
      },
      sync: {
        label: 'Sincronização',
        subModules: [
          {
            label: 'Sincronização',
            permissions: [
              {label: 'Sincronazação do Banco de Dados', value: 'sync.index'}
            ]
          }
        ]
      }
    }
  }
})
export default {
  namespaced: true,
  state: {
    ...mapStates(),
    all: [],
    one: Object.assign({}, model),
    validations: validations,
    loading: true,
    editing: false
  },
  mutations: {
    ...mapMutations()
  },
  actions: {
    ...mapActions(collection, model, connection)
  },
  getters: getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/roles.js